export enum MeasureTypes {
  firstAid = 'FirstAid',
  consultation = 'Consultation',
  rescueOperation = 'RescueOperation',
  other = 'Other'
}
